import { render, staticRenderFns } from "./personCert.vue?vue&type=template&id=057f652a&scoped=true"
import script from "./personCert.vue?vue&type=script&lang=js"
export * from "./personCert.vue?vue&type=script&lang=js"
import style0 from "./personCert.vue?vue&type=style&index=0&id=057f652a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f652a",
  null
  
)

export default component.exports